import{useState, useEffect} from 'react';

import api from '../../api';
import history from '../../history';

export default function useAuth(){
    const [authenticated, setAuthenticated ] = useState(false);
    const [user, setUser ] = useState(false);
    const [loading, setLoading ] = useState(true);

    useEffect(()=>{

        const token = localStorage.getItem('token');
        if(token){
            api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;
            setAuthenticated(true);
        }

        const user = localStorage.getItem('user');
        if(user){
            setUser(JSON.parse(user));
        }

        setLoading(false);
    },[]);

    async function handleLogin(email, password){


        const userLogin = {
            email: email,
            password : password
        }

        const formData = new FormData();
        formData.append('email', email);
        formData.append('password', password);

        let logado = false;
        await api.post('signin', formData)
        .then(res => {

            const { data } = res;

            setUser(data);

            localStorage.setItem('token', JSON.stringify(data.token));
            localStorage.setItem('user', JSON.stringify(data));
            api.defaults.headers.Authorization = `Bearer ${data.token}`;

            setAuthenticated(true);
            window.location.assign("/usuarios");
            
        })
        .catch((error) => {
            let msg = '';
            // Error
            if (error.response) {
                msg = error.response.data;
            }

            else if (error.request) {
                msg = error.request;
            }
            
            else {
                msg = error.message;
            }

            console.log(msg);
        });
              
    }

    function handleLogout(){
        setAuthenticated(false)

        localStorage.removeItem('token');
        localStorage.removeItem('user');

        api.defaults.headers.Authorization = undefined;
        window.location.assign("/login");
        //history.push('/login');

    }


    return { authenticated, user, loading, handleLogin, handleLogout};
}